module.exports = __webpack_public_path__ + "static/trevor-smith.919748d2.webp";